import { action } from '@ember/object';
import SettingsAreasBaseController from '../base';

export default class SettingsAreasAreaEditController extends SettingsAreasBaseController {
  @action
  cancel() {
    // Rollback changes to avoid persisting unsaved changes
    this.model.rollbackAttributes();
    this.goToListPage();
  }
}
